import React, {useState, useEffect} from "react";
import DataTable from "react-data-table-component";
import fetchWrapper from "../../utils/fetch/fetchWrapper";
import {BASE_URL} from '../../config';
import  adaptedImageUrl from '../../config'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import DataTableExtensions from "react-data-table-component-extensions";
import 'react-data-table-component-extensions/dist/index.css';
import {Col, Form, Modal, Row} from '@themesberg/react-bootstrap';
import {LOCAL_STORAGE} from "../../context/LocalStorage";
import ModalForm from "./ModalForm";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

export default function ServiceImage() {
    const [data, setData] = useState([]);
    const MySwal = withReactContent(Swal)
    const [showModal, setShowModal] = useState(false);
    const [idRowSelected, setIdRowSelected] = useState(null);
    const [imageSelected, setImageSelected] = useState(null);
    const [lightboxImage, setLightboxImage] = useState(false)


    let token = localStorage.getItem(LOCAL_STORAGE.AUTH_TOKEN)
    const fetchData = (event) => {
        fetchWrapper()
          .doPost({
              url: "/all_services_image",
              onSuccess: async (response) => {
                  setData(response.data.service_images)
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });

        // axios({
        //     method: "post",
        //     url: BASE_URL + "/all_services_image",
        //     headers: {
        //         'Authorization': token
        //     },
        //     timeout: 5000,
        // })
        //     .then(
        //         function (response) {
        //             if (response.data.status == 200) {
        //                 setData(response.data.service_images)
        //             }
        //         }.bind(this)
        //     )
        //     .catch(function (error) {
        //         console.log(error)
        //         if (error.response) {
        //             console.log(error.message);
        //             // console.log(response.data.message);
        //             alert(response.data.message);
        //         } else if (error.request) {
        //             alert("Error de conexion");
        //         } else {
        //             // console.log(error.message);
        //             alert(error.message);
        //         }
        //     });
    }

    useEffect(() => {
        fetchData()
    }, []);


    const setImageLightbox = (image_url) => {
        setImageSelected(image_url)
        setLightboxImage(true)
    }

    const CustomImage = ({row}) => (
        <div onClick={() => setImageLightbox(adaptedImageUrl(row.image_url_on))}>
            <img height="50px" width="50px" className="w-full  align-middle border-none shadow-lg"
                 src={adaptedImageUrl(row.image_url_on) ?? null}/>
        </div>
    );

    const TwoCustomImage = ({row}) => (
        <div onClick={() => setImageLightbox(adaptedImageUrl(row.image_url_off))}>
            <img height="50px" width="50px" className="w-full  align-middle border-none shadow-lg"
                 src={adaptedImageUrl(row.image_url_off) ?? null}/>
        </div>
    );

    const editModal = (id) => {
        setIdRowSelected(id)
        setShowModal(true)
    }

    const columns = [
                {
            name: "Identificador",
            selector: "id",
            sortable: true,
                                grow: 0,

        },
        {
            name: 'Imagen seleccionada',
            grow: 2,
            cell: row => <CustomImage row={row}/>,
        },
                {
            name: 'Imagen sin seleccionar',
            grow: 2, cell: row => <TwoCustomImage row={row}/>,

        },

                {
            name: 'Acciones',
            cell: row => <a onClick={() => editModal(row.id)}><i className="fas fa-edit"></i></a>,
        },
    ];

    const tableData = {
        columns,
        data
    };

    return (
        <>

            <ModalForm
                showModal={showModal}
                setShowModal={setShowModal}
                id={idRowSelected}
                setId={setIdRowSelected}
                fetchData={fetchData}
            />

                    {lightboxImage && (
          <Lightbox
            mainSrc={imageSelected}
            onCloseRequest={() => setLightboxImage(false)}
          />
        )}

            <div className="row mt-5 mb-5">
                <div className="col-md-10">
                    <h3>Administracion de imagenes de servicios</h3>
                </div>
                <div className="col-md-2">
                    <button style={{float: "right", marginRight: "20px"}} className="btn btn-primary mr-3"
                            onClick={() => setShowModal(true)}> Nuevo
                    </button>
                </div>
            </div>

            <DataTableExtensions {...tableData}>
                <DataTable
                    columns={columns}
                    data={data}
                    pagination
                    noHeader
                    paginationPerPage={10}
                />
            </DataTableExtensions>
        </>
    );
}
